export const INVALID_CONTENT = 'Invalid content';
export const INVALID_SRC_ATTR = 'Invalid worker attribute';
export const INVALID_WORKER_ATTR = 'Invalid worker attribute';
